import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as2003',
    ecrans: ['00-2'],
    params: ['id', '?atfcleint', '?datdeb', '?asgcleint', '?vaeatftyp', '?ecldsceta', '?demcleint', '?ptadatfin', '?ttccleint']
});
